import {
  Box,
  Button,
  Flex,
  FormControl,
  FormHelperText,
  FormLabel,
  Icon,
  Tooltip,
  Wrap,
  WrapItem,
} from '@chakra-ui/react';
import { FiCheck } from 'react-icons/fi';

import { BI_COLORS, BI_ICONS } from '../../../utils/biAppearance';

interface Props {
  color: string | null;
  icon: string | null;
  onChange: (value: { color: string | null; icon: string | null }) => void;
  // Cor/ícone efetivos, usados para pintar a seleção e o "padrão do grupo".
  previewColor: string;
  // No relatório, vazio = herda do grupo.
  allowInherit?: boolean;
}

export function AppearancePicker({
  color,
  icon,
  onChange,
  previewColor,
  allowInherit = false,
}: Props) {
  const inheritButton = (isActive: boolean, onClick: () => void) => (
    <WrapItem>
      <Button
        size="sm"
        h="8"
        variant={isActive ? 'solid' : 'outline'}
        colorScheme={isActive ? 'blue' : 'gray'}
        color={isActive ? 'white' : 'gray.50'}
        onClick={onClick}
        aria-pressed={isActive}
      >
        Padrão do grupo
      </Button>
    </WrapItem>
  );

  return (
    <>
      <FormControl as="fieldset">
        <FormLabel as="legend">Cor</FormLabel>
        <Wrap spacing="2" align="center">
          {allowInherit &&
            inheritButton(!color, () => onChange({ color: null, icon }))}
          {BI_COLORS.map(item => {
            const isActive = color === item.key;

            return (
              <WrapItem key={item.key}>
                <Tooltip label={item.label} bg="gray.650" hasArrow>
                  <Box
                    as="button"
                    type="button"
                    w="8"
                    h="8"
                    borderRadius="full"
                    bg={`${item.key}.400`}
                    color="white"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    borderWidth="2px"
                    borderColor={isActive ? 'gray.50' : 'transparent'}
                    _focus={{ boxShadow: 'outline' }}
                    aria-label={`Cor ${item.label}`}
                    aria-pressed={isActive}
                    onClick={() => onChange({ color: item.key, icon })}
                  >
                    {isActive && <Icon as={FiCheck} />}
                  </Box>
                </Tooltip>
              </WrapItem>
            );
          })}
        </Wrap>
      </FormControl>

      <FormControl as="fieldset">
        <FormLabel as="legend">Ícone</FormLabel>
        <Wrap spacing="2" align="center">
          {allowInherit &&
            inheritButton(!icon, () => onChange({ color, icon: null }))}
          {BI_ICONS.map(item => {
            const isActive = icon === item.key;

            return (
              <WrapItem key={item.key}>
                <Tooltip label={item.label} bg="gray.650" hasArrow>
                  <Flex
                    as="button"
                    type="button"
                    w="9"
                    h="9"
                    borderRadius="md"
                    align="center"
                    justify="center"
                    borderWidth="1px"
                    borderColor={isActive ? `${previewColor}.400` : 'gray.600'}
                    bg={isActive ? `${previewColor}.100` : 'transparent'}
                    color={isActive ? `${previewColor}.600` : 'gray.400'}
                    _hover={{ color: 'gray.50' }}
                    _focus={{ boxShadow: 'outline' }}
                    aria-label={`Ícone ${item.label}`}
                    aria-pressed={isActive}
                    onClick={() => onChange({ color, icon: item.key })}
                  >
                    <Icon as={item.icon} boxSize="5" />
                  </Flex>
                </Tooltip>
              </WrapItem>
            );
          })}
        </Wrap>
        <FormHelperText>
          Passe o mouse sobre o ícone para ver o nome.
        </FormHelperText>
      </FormControl>
    </>
  );
}
